"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderAPI = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.replace");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _helper = require("@/services/helper/helper.service");

var _request = require("@/services/request/request.service");

var _constants = require("@/store/last-mile-delivery/constants");

var _constants2 = require("@/store/milk-run/constants");

var DEFAULT_LMD_COLS = _constants.DEFAULT_ORDER_COLUMNS.map(function (col) {
  return col['code'];
});

var DEFAULT_MR_COLS = _constants2.DEFAULT_ORDER_COLUMNS.map(function (col) {
  return col['code'];
});

var OrderAPI = /*#__PURE__*/function () {
  function OrderAPI(_ref) {
    var lfToken = _ref.lfToken,
        userSetting = _ref.userSetting,
        userData = _ref.userData;
    (0, _classCallCheck2.default)(this, OrderAPI);
    this.lfToken = null;
    this.settings = {};
    this.userData = {};
    this.requestAuth = null;
    this.helper = new _helper.Helper();
    this.lfToken = lfToken;
    this.settings = userSetting;
    this.userData = userData;
    this.requestAuth = new _request.Request('application/json', this.lfToken);
  }

  (0, _createClass2.default)(OrderAPI, [{
    key: "$timezone",
    get: function get() {
      return this.helper.get(this.userData, 'timezone', 8);
    }
  }, {
    key: "getUnassignedOrders",
    value: function getUnassignedOrders(store) {
      var modeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'lastmile';
      var pageSize = store['pagination']['pageSize'];
      var currentPage = store['pagination']['currentPage'];
      var dateRangeOption = store['dateRangeOption'];
      var startTime = this.helper.revertTimezone(store['startDate'], this.$timezone);
      var endTime = this.helper.revertTimezone(store['endDate'], this.$timezone);
      var columns = store['orderColumns'];
      var excludeOrders = store['excludedOrders'].toString().replace(/,/g, '|');
      var includeOrders = store['includedOrders'].toString().replace(/,/g, '|');
      var exactValue = store['searchType'];
      var param = {
        modeType: modeType,
        limit: pageSize,
        page: currentPage,
        type: dateRangeOption,
        startTime: startTime,
        endTime: endTime,
        columns: columns,
        excludeOrders: excludeOrders,
        includeOrders: includeOrders,
        convertToString: true,
        exactValue: exactValue === 'exactSearch',
        order: 'dropBuilding:DESC'
      };
      var filters = store['orderFilters'];
      var filterQuery = this.helper.getFilterQuery(filters);

      if (!this.helper.isUndefined(filterQuery.queryAnd)) {
        param['queryAnd'] = filterQuery.queryAnd;
      }

      if (!this.helper.isUndefined(filterQuery.queryOr)) {
        param['queryOr'] = filterQuery.queryOr;
      }

      var filterExactQuery = this.helper.getExactFilterQuery(filters);

      if (filterExactQuery !== '') {
        param['exactQuery'] = filterExactQuery;
      } // if (filterExactQuery !== '') {
      //   param['queryAnd'] = filterExactQuery;
      //   param['exactValue'] = true;
      // }


      var filterOrder = OrderAPI.getFilterOrder(store);

      if (filterOrder !== '') {
        param['order'] = filterOrder;
      }

      var hook1 = this.helper.get(this.settings, 'hook1', '');

      if (!this.helper.isUndefined(hook1)) {
        return this.requestAuth.get(hook1, '', param, true);
      }

      return this.requestAuth.get('LEGACY_CORE_V3', 'routeplanning/joborders', param);
    }
  }, {
    key: "getOrderLocationLists",
    value: function getOrderLocationLists(_ref2) {
      var payload = _ref2.payload,
          dateRangeOption = _ref2.dateRangeOption;
      return this.requestAuth.get('LEGACY_CORE_V3', "routeplanning/location/".concat(payload['locationType']), {
        type: dateRangeOption,
        startTime: payload['startTime'],
        endTime: payload['endTime']
      });
    }
  }, {
    key: "getOrderColumnTemplates",
    value: function getOrderColumnTemplates(templateType) {
      return this.requestAuth.get('LEGACY_CORE', "setting?type=".concat(templateType));
    }
  }, {
    key: "postOrderColumnTemplate",
    value: function postOrderColumnTemplate(_ref3) {
      var templateType = _ref3.templateType,
          columns = _ref3.columns;
      return this.requestAuth.post('LEGACY_CORE', 'setting', {}, {
        type: templateType,
        settings: columns
      });
    }
  }, {
    key: "putOrderColumnTemplate",
    value: function putOrderColumnTemplate(_ref4) {
      var templateType = _ref4.templateType,
          columns = _ref4.columns;
      return this.requestAuth.put('LEGACY_CORE', "setting?type=".concat(templateType), {}, {
        settings: columns
      });
    }
  }, {
    key: "deleteOrderColumnTemplate",
    value: function deleteOrderColumnTemplate(templateType) {
      return this.requestAuth.delete('LEGACY_CORE', "setting?type=".concat(templateType));
    }
  }, {
    key: "downloadJobOrdersList",
    value: function downloadJobOrdersList(store) {
      var modeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'lastmile';
      var column = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_LMD_COLS || ['shipmentReference'];
      var assignedOrders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var assignedIndex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
      var dateRangeOption = store['dateRangeOption'];
      var startTime = this.helper.revertTimezone(store['startDate'], this.$timezone);
      var endTime = this.helper.revertTimezone(store['endDate'], this.$timezone);
      var excludeOrders = store['excludedOrders'].toString().replace(/,/g, '|');
      var includeOrders = store['includedOrders'].toString().replace(/,/g, '|');
      var exactValue = store['searchType'];
      var columns = (0, _toConsumableArray2.default)(column);

      if (modeType === 'milkrun') {
        columns = (0, _toConsumableArray2.default)(DEFAULT_MR_COLS) || ['shipmentReference'];
      }

      var param = {
        modeType: modeType,
        type: dateRangeOption,
        startTime: startTime,
        endTime: endTime,
        excludeOrders: excludeOrders,
        includeOrders: includeOrders,
        convertToString: true,
        exactValue: exactValue === 'exactSearch',
        order: 'id:ASC'
      };
      var filters = store['orderFilters'];
      var filterQuery = this.helper.getFilterQuery(filters);

      if (!this.helper.isUndefined(filterQuery.queryAnd)) {
        param['queryAnd'] = filterQuery.queryAnd;
      }

      if (!this.helper.isUndefined(filterQuery.queryOr)) {
        param['queryOr'] = filterQuery.queryOr;
      }

      var filterExactQuery = this.helper.getExactFilterQuery(filters);

      if (filterExactQuery !== '') {
        param['exactQuery'] = filterExactQuery;
      }

      var filterOrder = OrderAPI.getFilterOrder(store);

      if (filterOrder !== '') {
        param['order'] = filterOrder;
      }

      var hook1 = this.helper.get(this.settings, 'hook1', '');

      if (!this.helper.isUndefined(hook1)) {
        return this.requestAuth.post(hook1, '', param, true);
      }

      return this.requestAuth.post('LEGACY_CORE_V3', 'routeplanning/joborders', param, {
        type: 'xls',
        column: columns,
        assignedOrders: assignedOrders,
        assignedIndex: assignedIndex
      });
    }
  }], [{
    key: "getFilterOrder",
    value: function getFilterOrder(store) {
      var order = store['pagination']['order'];
      var orderBy = store['pagination']['orderBy'];
      return orderBy !== null && orderBy !== '' ? "".concat(orderBy, ":").concat(order) : '';
    }
  }]);
  return OrderAPI;
}();

exports.OrderAPI = OrderAPI;